import React from "react";
import { Link } from "react-router-dom";
import "./RelatedArticles.css";
import { FaArrowRight, FaRegCalendarAlt, FaRegClock } from "react-icons/fa";
import defaultBlogImg1 from "../../../assets/img/blog1.webp";
import defaultBlogImg2 from "../../../assets/img/blog2.webp";
import BlogCard from "./BlogCard";

function formatArticleDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;

  const day = date.getUTCDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

  const month = date.toLocaleDateString("en-GB", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();
  return `${day}${suffix} ${month}, ${year}`;
}

function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

// 360 Bytes published articles (from Footer & LayoutRoutes)
const SITE_ARTICLES = [
  {
    title: "Custom Web Design Solutions in Qatar: Tailored for Success",
    slug: "custom-web-design-solutions-in-qatar-tailored-for-success",
    link: "/custom-web-design-solutions-in-qatar-tailored-for-success",
    image: defaultBlogImg1,
    imageAlt: "Custom Web Design Solutions in Qatar",
    date: "28th Nov, 2024",
    readTime: "5 min read",
    excerpt:
      "Explore how custom web designs tailored for Qatar's unique business landscape empower brands to achieve superior visibility and conversion rates.",
  },
  {
    title: "How Cloud Computing Is Transforming Businesses In Qatar",
    slug: "how-cloud-computing-is-transforming-businesses-in-qatar",
    link: "/how-cloud-computing-is-transforming-businesses-in-qatar",
    image: defaultBlogImg2,
    imageAlt: "How Cloud Computing Is Transforming Businesses In Qatar",
    date: "14th Dec, 2024",
    readTime: "6 min read",
    excerpt:
      "Discover how cloud infrastructure, serverless agility, and enterprise security are revolutionizing performance and scalability for businesses across Qatar.",
  },
  {
    title: "Why Choose a Professional Website Design and Development Company",
    slug: "why-choose-a-professional-website-design-and-development-company",
    link: "/blogs/why-choose-a-professional-website-design-and-development-company",
    image:
      "https://admin.360-bytes.com/storage/blogs/f9fG7Q1EWaCcZPknrlv38Qnm4Ut5RwMwW9eppB8A.png",
    imageAlt: "Website Design and Development Company in Qatar",
    date: "22nd Oct, 2026",
    readTime: "4 min read",
    excerpt:
      "Customers generally find out about businesses through a website. A well-designed website helps make a strong impression and communicate your brand value.",
  },
];

export default function RelatedArticles({ recentBlogs = [], currentSlug = "" }) {
  // 1. Process any other blogs returned from the API
  const apiArticles = (recentBlogs || [])
    .filter((b) => b && b.slug !== currentSlug)
    .map((b) => ({
      title: b.title,
      slug: b.slug,
      link: `/blogs/${b.slug}`,
      featured_image_url: b.featured_image_url || b.featured_image || defaultBlogImg1,
      imageAlt: b.featured_image_alt || b.title,
      readTime: b.estimated_reading_time
        ? `${b.estimated_reading_time} min read`
        : "",
      date: b.published_at ? formatArticleDate(b.published_at) : "",
      description: b.description
        ? stripHtml(b.description).slice(0, 130) + "..."
        : "",
    }));

  // 2. Identify existing slugs so we never duplicate the current blog or added blogs
  const existingSlugs = new Set([
    currentSlug,
    ...apiArticles.map((a) => a.slug),
  ]);

  // 3. Supplement with the site's other genuine published articles
  const companionArticles = apiArticles.filter(
    (a) => !existingSlugs.has(a.slug)
  );

  const finalArticles = [...apiArticles, ...companionArticles].slice(0, 3);

  if (finalArticles.length === 0) {
    return null;
  }

  const handleCardClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="related-articles-sec" aria-labelledby="related-heading">
      <div className="container">
        {/* Section Header */}
        <div className="related-articles-header">
          <span className="related-badge">RECOMMENDED INSIGHTS</span>
          <h2 id="related-heading" className="related-title">
            Related Articles
          </h2>
          <p className="related-subtitle">
            Explore more insights and perspectives from 360 Bytes.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="related-articles-grid">
          {finalArticles.map((article, index) => (
            <article
              key={article.slug || index}
              className="blogs-grid"
            >
              {/* <Link
                to={article.link}
                onClick={handleCardClick}
                className="related-card-link"
                tabIndex={-1}
                aria-hidden="true"
              >
                <div className="related-image-wrapper">
                  <img
                    src={article.image}
                    alt={article.imageAlt || article.title}
                    width={400}
                    height={240}
                    loading="lazy"
                    className="related-image"
                  />
                </div>
              </Link>

              <div className="related-card-content">
                <div className="related-meta-row">
                  {article.date && (
                    <span className="related-meta-item">
                      <FaRegCalendarAlt className="related-meta-icon" />
                      {article.date}
                    </span>
                  )}
                  {article.readTime && (
                    <span className="related-meta-item">
                      <FaRegClock className="related-meta-icon" />
                      {article.readTime}
                    </span>
                  )}
                </div>

                <h3 className="related-card-title">
                  <Link to={article.link} onClick={handleCardClick}>
                    {article.title}
                  </Link>
                </h3>

                {article.excerpt && (
                  <p className="related-card-excerpt">{article.excerpt}</p>
                )}

                <div className="related-card-footer">
                  <Link
                    to={article.link}
                    onClick={handleCardClick}
                    className="related-read-more"
                  >
                    <span>Read Article</span>
                    <FaArrowRight className="related-arrow-icon" />
                  </Link>
                </div>
              </div> */}
              <BlogCard key={article.id || article.slug || index} blog={article} />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}